import React, { useEffect, useMemo } from "react";
// Import images
import m1 from "../../../../../Assets/Images/defaultMedia1.jpeg";
import m2 from "../../../../../Assets/Images/defaultMedia2.jpeg";
import m3 from "../../../../../Assets/Images/defaultMedia3.jpeg";
import { FadeLoader } from "react-spinners";
import InfiniteScroll from "../../../../../Components/InfiniteScroll/InfiniteScroll";
import { FaFileVideo } from "react-icons/fa";

const isImageFile = (url) => {
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
  const videoExtensions = [".mp4", ".webm", ".mov", ".avi", ".mkv"];

  const lowerUrl = url.toLowerCase();

  // Check if URL contains image extension
  if (imageExtensions.some((ext) => lowerUrl.includes(ext))) {
    return true;
  }

  // Check if URL contains video extension
  if (videoExtensions.some((ext) => lowerUrl.includes(ext))) {
    return false;
  }
  // Default to image if no extension matches
  return true;
};

export default function Media({
  mediaList,
  isMediaLoading,
  getMediaList,
  mediaCurrentPage,
  mediaTotalPage,
  chatConversationId,
}) {
  useEffect(() => {
    getMediaList("MEDIA");
  }, [chatConversationId]);

  const groupedData = useMemo(() => {
    const groupedData = {};
    mediaList.forEach((item) => {
      const date = new Date(item.sentTime).toLocaleDateString("en-US", {
        timeZone: "Asia/Kolkata",
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
      groupedData[date] = groupedData[date] || [];
      groupedData[date].push(item);
    });
    return groupedData;
  }, [mediaList]);

  const fetchMoreMedia = async () => {
    if (mediaCurrentPage < mediaTotalPage) {
      await getMediaList("MEDIA", mediaCurrentPage + 1);
    }
  };

  const downloadFile = (url) => {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.download = url;
    a.click();
  };
  return (
    <section>
      {isMediaLoading ? (
        <div className="flex justify-center items-center h-full  mt-5">
          <FadeLoader color="#7104F8" size={15} margin={2} />
        </div>
      ) : mediaList.length <= 0 ? (
        <div className="flex justify-center items-center h-full">
          <p className="text-gray-500">No media found</p>
        </div>
      ) : (
        <InfiniteScroll
          dataLength={mediaList.length}
          next={fetchMoreMedia}
          hasMore={mediaCurrentPage < mediaTotalPage}
          loader={
            <p className="text-gray-500 text-center">Loading more media...</p>
          }
        >
          {Object.entries(groupedData)
            .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA))
            .map(([date, items]) => (
              <div key={date}>
                <label className="text-sm font-semibold">{date}</label>
                <div className="flex flex-wrap gap-4 mt-2">
                  {items.map((item, index) => (
                    <div
                      key={index}
                      className="min-w-[114px] min-h-[114px] max-w-[114px] max-h-[114px] rounded-xl overflow-hidden"
                      onClick={() => downloadFile(item.mediaUrl)}
                    >
                      {item.mediaId.fileType === "video" ? (
                        <video
                          controls
                          src={item.mediaUrl}
                          className="h-[114px] w-[228px] object-contain"
                        />
                      ) : (
                        <img
                          src={item.mediaUrl}
                          alt={`media-${index}`}
                          className="h-[114px] w-full object-cover"
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </InfiniteScroll>
      )}
    </section>
  );
}
